import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useParams, useNavigate, useLocation, useSearchParams, } from "react-router-dom";
import { getRequest, patchRequest } from "../../axios";
import { authUserData } from "../../utils/Helper";
import { Checkbox, Collapse, Form, Input, Spin, Table, Breadcrumb } from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { useTranslation } from "react-i18next";
import {
    ErrorNotificationMsg,
    SuccessNotificationMsg,
} from "../../utils/Notifications";

const VendorViewRFQBidDetail = () => {
    const { id } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const formRef = useRef();
    const [siteGstRates, setSiteGstRates] = useState({});
    const VendorId = authUserData()?.vendor ? authUserData()?.vendor : null;
    const [apiLoading, setapiLoading] = useState(false);
    const [newState2, setNewState2] = useState([]);
    const [data, setData] = useState([]);
    const [CategoryId, setCtaegoryTree] = useState();
    const vendorBidId = id ? id : null;
    const [disabled, setDisabled] = useState(true);
    const [vendorBidRFQ2, setVendorBidRFQ2] = useState([]);
    const [loading, setLoading] = useState(false);
    const [companyName, setCompanyName] = useState([]);
    const [rfqnumber, setRFQNumber] = useState([]);
    const [AsFinalBidPrice, setIsFinalBidPrice] = useState("");
    const [rfqcurrency, setRFQCurrency] = useState([]);
    const [rfqfreight, setRFQFreight] = useState([]);
    const [rfqunloading, setRFQUnloading] = useState([]);
    const [rfqpricebasis, setRFQPriceBasis] = useState([]);
    const [rfqtransportInsurance, setRFQTransportInsurance] = useState([]);
    const [showUnitRateCementR1, setShowUnitRateCementR1] = useState(false);
    const [isSubmitClicked, setIsSubmitClicked] = useState(false);
    const [gstInitialValue, setGstInitialValue] = useState(false);
    const [isSubmitClicked2, setIsSubmitClicked2] = useState(false);
    const [firstClick, setFirstClick] = useState(true);
    const [enableInputsR1, setEnableInputsR1] = useState(false);
    const [enableInputs, setEnableInputs] = useState(false);
    const [showUnitRateCementR, setShowUnitRateCementR] = useState(false);
    const [isDatePickerDisabled, setIsDatePickerDisabled] = useState(false);
    const [isDatePickerDisabledR1, setIsDatePickerDisabledR1] = useState(false);
    const [isSubmitClicked3, setIsSubmitClicked3] = useState(false);
    const [rfqopenorder, setRFQOpenOrder] = useState(false);
    const [rfqpricecap, setRFQPriceCap] = useState([]);
    const [trackingOfStages, setTrackingOfStages] = useState(0);
    const [showAdditionalCheckboxesFinal, setShowAdditionalCheckboxesFinal] =
        useState(true);
    const [showAdditionalCheckboxes, setShowAdditionalCheckboxes] =
        useState(false);
    const [hiddenDatepickerData, sethiddenDatepicker] = useState(false);
    const [hideInitialBIDPriceCementR0, setHideInitialBIDPriceCementR0] =
        useState(false);
    const [hideInitialBIDPriceFreightR0, setHideInitialBIDPriceFreightR0] =
        useState(false);
    const [hideInitialBIDPriceTotalR0, setHideInitialBIDPriceTotalR0] =
        useState(false);
    const [hideInitialBIDPriceCementR1, setHideInitialBIDPriceCementR1] =
        useState(false);
    const [hideInitialBIDPriceFreightR1, setHideInitialBIDPriceFreightR1] =
        useState(false);
    const [hideInitialBIDPriceTotalRateR1, setHideInitialBIDPriceTotalRateR1] =
        useState(false);
    const [hideInitialBIDPriceDateR1, setHideInitialBIDPriceDateR1] =
        useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [buyingPattern, setBuyingPattern] = useState("");
    const [hideUnitRateOfCementR0, setHideUnitRateOfCementR0] = useState(false);
    const [hideUnitRateOfFreightR0, setHideUnitRateOfFreightR0] = useState(true);
    const [showUnitRateOfCement, setShowUnitRateOfCement] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [hideR0, setHideR0] = useState(false);
    const [hideR1, setHideR1] = useState(false);
    const [summaryTableData, setSummaryTableData] = useState([]);
    const [resetMode, setResetMode] = useState(false);
    const [revisedDate, setRevisedDate] = useState(false);
    const [finalDate, setFinalDate] = useState(false);
    const [isFinal, setIsFinal] = useState(false);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const action = queryParams.get("vendor_id");
    const actionCreate = queryParams.get("create_bid");
    console.log("actionCreate", actionCreate);
    const handleHideR0Change = (e) => {
        setHideR0(e.target.checked);
    };
    const handleHideR1Change = (e) => {
        setHideR1(e.target.checked);
    };
    const { Panel } = Collapse;

    const currentDate = (() => {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const yyyy = today.getFullYear();

        return `${dd}-${mm}-${yyyy}`;
    })();

    const [state, setState] = useState([]);
    const [rfqData, setRfqData] = useState({
        open_order: false,
        rfqamountcap: "",
        rfqtimelinecap: "",
        rfqopendeliverydate: "",
        rfqdeliverystartdate: "",
        rfqdeliveryenddate: "",
        rfqduedate: "",
        rfqpricecap: "",
    });

    const [showUnitRateOfFreight, setShowUnitRateOfFreight] = useState(false);

    const calculateUnitRateWithGst = (initialBidPriceUnitRate, quantity, gstRate) => {
        return (
            initialBidPriceUnitRate * quantity * (gstRate / 100) +
            initialBidPriceUnitRate
        );
    };


    const resetGSTValues = useCallback(() => {
        setTableData((prevData) =>
            prevData.map((item) => {
                if (item.material_type_name) {
                    return {
                        ...item,
                        unit_rate_with_gst: 0,
                    };
                }
                return item;
            })
        );
        setResetMode(true);

        setSummaryTableData((prevSummaryData) =>
            prevSummaryData.map((city) => ({
                ...city,
                sites: city.sites.map((site) => ({
                    ...site,
                    totalAmountWithGst: 0,
                    totalAmountWithoutGst: 0,
                })),
            }))
        );
    }, [setTableData, setResetMode]);

    const handleInputChangeUnitRateWIthGST = (e, siteId, materialType) => {
        const { value } = e.target;

        setData((prevData) =>
            prevData.map((city) => ({
                ...city,
                bid_rfq_city_detail: city.bid_rfq_city_detail.map((site) =>
                    site.site_id === siteId
                        ? {
                        ...site,
                        material_details: site.material_details.map((material) =>
                            material.material_type === materialType
                                ? { ...material, unit_rate_with_gst: value }
                                : material
                        ),
                    }
                        : site
                ),
            }))
        );
    };

    const handleInputChangeLQPForThisClient = (e, siteId, materialType) => {
        const { value } = e.target;

        setData((prevData) =>
            prevData.map((city) => ({
                ...city,
                bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
                    site.site_id === siteId
                        ? {
                        ...site,
                        bid_rfq_material_details: site.bid_rfq_material_details.map(
                            (material) =>
                                material.material_type === materialType
                                    ? { ...material, lqp_for_this_client: value }
                                    : material
                        ),
                    }
                        : site
                ),
            }))
        );
    };

    const handleInputChangeAnyLqp = (e, siteId, materialType) => {
        const { value } = e.target;

        setData((prevData) =>
            prevData.map((city) => ({
                ...city,
                bid_rfq_site_details: city.bid_rfq_site_details.map((site) =>
                    site.site_id === siteId
                        ? {
                        ...site,
                        bid_rfq_material_details: site.bid_rfq_material_details.map(
                            (material) =>
                                material.material_type === materialType
                                    ? { ...material, lqp_for_this_any_client: value }
                                    : material
                        ),
                    }
                        : site
                ),
            }))
        );
    };
    const handleDateChange = (cityIndex, siteIndex, field, value) => {
        const newData = [...tableData];
        newData[cityIndex].bid_rfq_site_details[siteIndex][field] = value;
        setTableData(newData);
    };
    useEffect(() => {
        const getVendorBidRFQ = async () => {
            setapiLoading(true);
            try {
                const response1 = await getRequest(
                    `bid-rfq/${vendorBidId}/get-bid-rfq-city-wise/?vendor_id=${action}`
                );

                const abc = response1.data.data;


                let cityTotals = {};
                let serialNumber = 0;
                let lastCityName = null;
                let lastSiteName = null;

                const fattenData = abc.bid_rfq_city_wise_detail.flatMap(
                    (cityDetail) => {
                        const siteMap = {};
                        let cityTotal = {
                            initial_bid_price_unit_rate: 0,
                            initial_bid_price_unit_rate_of_freight: 0,
                            material_total_quantity: 0,
                            gst_rate: 0,
                            unit_rate_with_gst: 0,
                            revised_bid_price_unit_rate: 0,
                            revised_bid_price_unit_rate_of_freight: 0,
                            final_bid_price_unit_rate: 0,
                            final_bid_price_unit_rate_of_freight: 0,


                        };

                        cityDetail.bid_rfq_site_details.forEach((siteDetail) => {
                            const siteId = siteDetail.site_id;

                            if (!siteMap[siteId]) {
                                siteMap[siteId] = {
                                    ...siteDetail,
                                    bid_rfq_material_details: [],
                                    showSiteName: true,
                                    subtotal: {
                                        initial_bid_price_unit_rate: 0,
                                        initial_bid_price_unit_rate_of_freight: 0,
                                        material_total_quantity: 0,
                                        gst_rate: 0,
                                        unit_rate_with_gst: 0,
                                        revised_bid_price_unit_rate: 0,
                                        revised_bid_price_unit_rate_of_freight: 0,
                                        final_bid_price_unit_rate: 0,
                                        final_bid_price_unit_rate_of_freight: 0,
                                    },
                                };
                            }

                            siteDetail.bid_rfq_material_details.forEach((materialDetail) => {
                                const materialType = materialDetail.material_type;
                                const existingMaterial = siteMap[
                                    siteId
                                    ].bid_rfq_material_details.find(
                                    (material) => material.material_type === materialType
                                );

                                if (existingMaterial) {
                                    existingMaterial.material_total_quantity +=
                                        materialDetail.material_total_quantity || 0;
                                    existingMaterial.gst_rate += materialDetail.gst_rate || 0;
                                    existingMaterial.initial_bid_price_unit_rate +=
                                        materialDetail.initial_bid_price_unit_rate || 0;
                                    existingMaterial.initial_bid_price_unit_rate_of_freight +=
                                        materialDetail.initial_bid_price_unit_rate_of_freight || 0;
                                    existingMaterial.unit_rate_with_gst +=
                                        materialDetail.unit_rate_with_gst || 0;
                                    existingMaterial.revised_bid_price_unit_rate +=
                                        materialDetail.revised_bid_price_unit_rate || 0;
                                    existingMaterial.revised_bid_price_unit_rate_of_freight +=
                                        materialDetail.revised_bid_price_unit_rate_of_freight || 0;
                                    existingMaterial.final_bid_price_unit_rate +=
                                        materialDetail.final_bid_price_unit_rate || 0;
                                    existingMaterial.final_bid_price_unit_rate_of_freight +=
                                        materialDetail.final_bid_price_unit_rate_of_freight || 0;
                                } else {
                                    siteMap[siteId].bid_rfq_material_details.push({
                                        ...materialDetail,
                                    });
                                }
                                siteMap[siteId].subtotal.initial_bid_price_unit_rate +=
                                    materialDetail.initial_bid_price_unit_rate || 0;
                                siteMap[
                                    siteId
                                    ].subtotal.initial_bid_price_unit_rate_of_freight +=
                                    materialDetail.initial_bid_price_unit_rate_of_freight || 0;
                                siteMap[siteId].subtotal.material_total_quantity +=
                                    materialDetail.material_total_quantity || 0;
                                siteMap[siteId].subtotal.gst_rate +=
                                    materialDetail.gst_rate || 0;
                                siteMap[siteId].subtotal.unit_rate_with_gst +=
                                    materialDetail.unit_rate_with_gst || 0;
                                siteMap[siteId].subtotal.revised_bid_price_unit_rate +=
                                    materialDetail.revised_bid_price_unit_rate || 0;
                                siteMap[
                                    siteId
                                    ].subtotal.revised_bid_price_unit_rate_of_freight +=
                                    materialDetail.revised_bid_price_unit_rate_of_freight || 0;
                                siteMap[siteId].subtotal.final_bid_price_unit_rate +=
                                    materialDetail.final_bid_price_unit_rate || 0;
                                siteMap[siteId].subtotal.final_bid_price_unit_rate_of_freight +=
                                    materialDetail.final_bid_price_unit_rate_of_freight || 0;

                                cityTotal.initial_bid_price_unit_rate +=
                                    materialDetail.initial_bid_price_unit_rate || 0;
                                cityTotal.initial_bid_price_unit_rate_of_freight +=
                                    materialDetail.initial_bid_price_unit_rate_of_freight || 0;
                                cityTotal.material_total_quantity +=
                                    materialDetail.material_total_quantity || 0;
                                cityTotal.gst_rate += materialDetail.gst_rate || 0;
                                cityTotal.unit_rate_with_gst +=
                                    materialDetail.unit_rate_with_gst || 0;
                                cityTotal.revised_bid_price_unit_rate +=
                                    materialDetail.revised_bid_price_unit_rate || 0;
                                cityTotal.revised_bid_price_unit_rate_of_freight +=
                                    materialDetail.revised_bid_price_unit_rate_of_freight || 0;
                                cityTotal.final_bid_price_unit_rate +=
                                    materialDetail.final_bid_price_unit_rate || 0;
                                cityTotal.final_bid_price_unit_rate_of_freight +=
                                    materialDetail.final_bid_price_unit_rate_of_freight || 0;
                            });
                        });

                        const siteRows = Object.values(siteMap).flatMap((site) => {
                            const materialRows = site.bid_rfq_material_details.map(
                                (material) => {
                                    const isCityChanged = lastCityName !== cityDetail.city_name;
                                    const isSiteChanged = lastSiteName !== site.site_name;

                                    if (isCityChanged) {
                                        serialNumber++;
                                        lastCityName = cityDetail.city_name;
                                    }

                                    if (isSiteChanged) {
                                        lastSiteName = site.site_name;
                                    }
                                    if (material.revised_bid_price_date !== null) {
                                        setRevisedDate(true);
                                    } else {
                                        setRevisedDate(false);
                                    }

                                    if (material.final_bid_price_date !== null) {
                                        setFinalDate(true);
                                    } else {
                                        setFinalDate(false);
                                    }
                                    return {
                                        sr_no: isCityChanged ? serialNumber : null,
                                        city_name: isCityChanged
                                            ? cityDetail.city_name || null
                                            : null,
                                        site_name: isSiteChanged ? site.site_name || null : null,
                                        siteId: site.site_id,
                                        material_type_name: material.material_type_name || "",
                                        material_wise_uom: material.material_wise_uom || "",
                                        material_type: material.material_type || null,
                                        material_total_quantity:
                                        material.material_total_quantity || 0,
                                        gst_rate: material.gst_rate || 0,
                                        initial_bid_price_unit_rate:
                                        material.initial_bid_price_unit_rate || 0,
                                        initial_bid_price_unit_rate_of_freight:
                                        material.initial_bid_price_unit_rate_of_freight || 0,
                                        initial_bid_price_date:
                                        material.initial_bid_price_date || "",
                                        revised_bid_price_unit_rate:
                                        material.revised_bid_price_unit_rate || 0,
                                        revised_bid_price_unit_rate_of_freight:
                                        material.revised_bid_price_unit_rate_of_freight || 0,
                                        revised_bid_price_date:
                                        material.revised_bid_price_date || "",
                                        final_bid_price_unit_rate:
                                        material.final_bid_price_unit_rate || 0,
                                        final_bid_price_unit_rate_of_freight:
                                        material.final_bid_price_unit_rate_of_freight || 0,
                                        final_bid_price_date: material.final_bid_price_date || "",
                                        unit_rate_with_gst: material.unit_rate_with_gst || 0,
                                    };
                                }
                            );

                            // Add subtotal row
                            const subtotalRow = {
                                sr_no: null,
                                city_name: null,
                                site_name: "Subtotal",
                                siteId: site.site_id,
                                material_type_name: "",
                                material_wise_uom: "",
                                material_type: null,
                                material_total_quantity: site.subtotal.material_total_quantity,
                                gst_rate: site.subtotal.gst_rate,
                                initial_bid_price_unit_rate:
                                site.subtotal.initial_bid_price_unit_rate,
                                initial_bid_price_unit_rate_of_freight:
                                site.subtotal.initial_bid_price_unit_rate_of_freight,
                                initial_bid_price_date: "",
                                revised_bid_price_unit_rate:
                                site.subtotal.revised_bid_price_unit_rate,
                                revised_bid_price_unit_rate_of_freight:
                                site.subtotal.revised_bid_price_unit_rate_of_freight,
                                revised_bid_price_date: "",
                                final_bid_price_unit_rate:
                                site.subtotal.final_bid_price_unit_rate,
                                final_bid_price_unit_rate_of_freight:
                                site.subtotal.final_bid_price_unit_rate_of_freight,
                                final_bid_price_date: "",
                                unit_rate_with_gst: site.subtotal.unit_rate_with_gst,
                            };

                            return [...materialRows, subtotalRow];
                        });

                        // Add city total row
                        const cityTotalRow = {
                            sr_no: null,
                            // city_name: cityDetail.city_name,
                            site_name: "City Total",
                            siteId: null,
                            material_type_name: "",
                            material_wise_uom: "",
                            material_type: null,
                            material_total_quantity: cityTotal.material_total_quantity,
                            gst_rate: cityTotal.gst_rate,
                            initial_bid_price_unit_rate:
                            cityTotal.initial_bid_price_unit_rate,
                            initial_bid_price_unit_rate_of_freight:
                            cityTotal.initial_bid_price_unit_rate_of_freight,
                            initial_bid_price_date: "",
                            revised_bid_price_unit_rate:
                            cityTotal.revised_bid_price_unit_rate,
                            revised_bid_price_unit_rate_of_freight:
                            cityTotal.revised_bid_price_unit_rate_of_freight,
                            revised_bid_price_date: "",
                            final_bid_price_unit_rate: cityTotal.final_bid_price_unit_rate,
                            final_bid_price_unit_rate_of_freight:
                            cityTotal.final_bid_price_unit_rate_of_freight,
                            final_bid_price_date: "",
                            unit_rate_with_gst: cityTotal.unit_rate_with_gst,
                        };

                        return [...siteRows, cityTotalRow];
                    }
                );

                setTableData(fattenData);

                const isFinalBidPrice = abc.is_final_bid_price;
                setCompanyName(abc.company);
                setIsFinalBidPrice(abc.is_final_bid_price);
                setRFQNumber(abc.rfq_number);
                setRFQCurrency(abc.currency_name);
                setRFQPriceBasis(abc.price_basis);
                setRFQFreight(abc.freight);
                setRFQUnloading(abc.unloading);
                setRFQTransportInsurance(abc.transport_insurance);
                setRFQOpenOrder(abc.open_order);
                setRFQPriceCap(abc.price_cap);

                setRfqData({
                    open_order: abc.open_order,
                    rfqamountcap: abc.amount_cap,
                    rfqtimelinecap: abc.timeline_cap,
                    rfqopendeliverydate: abc.delivery_date,
                    rfqdeliverystartdate: abc.delivery_start_date,
                    rfqdeliveryenddate: abc.delivery_end_date,
                    rfqduedate: abc.rfq_due_date,
                    rfqpricecap: abc.price_cap,
                });
                setState((prevState) => {
                    return {
                        ...prevState,
                        bid_rfq_city_wise_detail: abc.bid_rfq_city_wise_detail,
                    };
                });

                const AsFinalBidPrice = abc.is_final_bid_price;

                const r1FinalPrice =
                    abc.bid_rfq_city_wise_detail[0].bid_rfq_site_details[0]
                        .bid_rfq_material_details[0].revised_bid_price_unit_rate > 0;

                const rFinalPrice =
                    abc.bid_rfq_city_wise_detail[0].bid_rfq_site_details[0]
                        .bid_rfq_material_details[0].final_bid_price_unit_rate;


                if (r1FinalPrice && AsFinalBidPrice) {
                    setShowUnitRateOfCement(true);
                    setHideR1(true);
                    setShowUnitRateCementR1(false);
                    setShowUnitRateCementR(false);
                } else if (rFinalPrice && AsFinalBidPrice) {
                    setShowUnitRateOfCement(true);
                    setShowUnitRateCementR1(true);
                    setShowUnitRateCementR(true);
                } else if (AsFinalBidPrice === "true") {
                    setShowUnitRateOfCement(true);
                    setShowUnitRateCementR1(false);
                    setShowUnitRateCementR(false);
                } else {
                    setShowUnitRateOfCement(true);
                    setShowUnitRateCementR1(true);
                    setShowUnitRateCementR(true);
                }

                setIsFinalBidPrice(AsFinalBidPrice);
                const buying_pattern = abc.buying_pattern;
                setBuyingPattern(buying_pattern);
                if (buying_pattern === "Unit Rate of Cement excluding Freight") {
                    setShowUnitRateOfCement(true);
                    setShowUnitRateOfFreight(true);
                } else if (buying_pattern === "Unit Rate of Cement including Freight") {
                    setShowUnitRateOfCement(true);
                    setShowUnitRateOfFreight(false);
                } else if (buying_pattern === "Total Unit Rate") {
                    setShowUnitRateOfCement(false);
                    setShowUnitRateOfFreight(true);
                }
            } catch (error) {
                console.error("Error:", error);
                setapiLoading(false);
            } finally {
                setapiLoading(false);
            }
        };

        if(actionCreate) {
            navigate(`/rfq-vendor-request-for-quotation-city-wise/bid-rfq/${btoa(vendorBidId)}`);
        } else {
            getVendorBidRFQ();
        }
    }, [vendorBidId]);
    const [siteWithoutGstRates, setSiteWithoutGstRates] = useState({});
    const hideR1Columns = hideR1 ? [] : {};

    const calculateSubtotals = (tableData) => {
        let siteSubtotals = {};
        let grandTotalCement = 0;
        let grandTotalFreight = 0;

        tableData.forEach((record) => {
            if (!record.isSubtotal) {
                const siteId = record.siteId;
                if (!siteSubtotals[siteId]) {
                    siteSubtotals[siteId] = {
                        totalCement: 0,
                        totalFreight: 0,
                    };
                }
                siteSubtotals[siteId].totalCement += Number(
                    record.initial_bid_price_unit_rate || 0
                );
                siteSubtotals[siteId].totalFreight += Number(
                    record.initial_bid_price_unit_rate_of_freight || 0
                );
                grandTotalCement += Number(record.initial_bid_price_unit_rate || 0);
                grandTotalFreight += Number(
                    record.initial_bid_price_unit_rate_of_freight || 0
                );
            }
        });

        return { grandTotalCement, grandTotalFreight, siteSubtotals };
    };

    const { grandTotalCement, grandTotalFreight, siteSubtotals } =
        calculateSubtotals(tableData);

    const columns = [
        {
            title: "Sr.",
            dataIndex: "sr_no",
            key: "sr_no",
            width: 50,
        },
        {
            title: "City",
            dataIndex: "city_name",
            key: "city_name",
            width: 120,
        },
        {
            title: "Site",
            dataIndex: "site_name",
            key: "site_name",
            width: 120,
            render: (text, record) => {
                if (record?.site_name === "Subtotal") {
                    return <div className="subtotal">{"Sub total"}</div>;
                } else if (record?.site_name === "City Total") {
                    return <div className="citytotal">{"City total"}</div>;
                } else {
                    return <>{record.site_name}</>;
                }
            }
        },
        {
            title: "Material Type",
            dataIndex: "material_type_name",
            key: "material_type_name",
            width: 130,
        },

        {
            title: "Total Quantity",
            dataIndex: "material_total_quantity",
            className: 'column-right',
            key: "material_total_quantity",
            width: 80,
            render: (text, record) => {
                if (record?.site_name === "Subtotal") {
                    return <div className="subtotal">{record.material_total_quantity}</div>;
                } else if (record?.site_name === "City Total") {
                    return <div className="citytotal">{record.material_total_quantity}</div>;
                } else {
                    return <div className="normal-field">{record.material_total_quantity}</div>;
                }

            },
        },
        {
            title: "UoM.",
            dataIndex: "material_wise_uom",
            key: "material_wise_uom",
            width: 60,
        },

        !hideR0 && {
            title: "R0",
            children: [
                (buyingPattern === "Unit Rate of Cement including Freight" ||
                buyingPattern === "Unit Rate of Cement excluding Freight") &&
                showUnitRateOfCement && {
                    title: "Unit Rate",
                    className: 'column-right',
                    width: 150,
                    dataIndex: "initial_bid_price_unit_rate",
                    key: "initial_bid_price_unit_rate",
                    render: (text, record) => {
                        const isSubtotal = record.isSubtotal;
                        if (record?.site_name === "Subtotal") {
                            return <div className="subtotal">₹ {record.initial_bid_price_unit_rate.toLocaleString('en-IN', { maximumFractionDigits: 0 }) ?? ""}</div>;
                        } else if (record?.site_name === "City Total") {
                            return <div className="citytotal">₹ {record.initial_bid_price_unit_rate.toLocaleString('en-IN', { maximumFractionDigits: 0 }) ?? ""}</div>;
                        } else {
                            return <div className="normal-field">₹ {record.initial_bid_price_unit_rate.toLocaleString('en-IN', { maximumFractionDigits: 0 }) ?? ""}</div>;
                        }
                    },
                },

                buyingPattern === "Unit Rate of Cement excluding Freight" &&
                showUnitRateOfFreight && {
                    title: "Unit Rate of Freight",
                    dataIndex: "initial_bid_price_unit_rate_of_freight",
                    key: "initial_bid_price_unit_rate_of_freight",
                    render: (text, record) => {
                        const isSubtotal = record.isSubtotal;
                        if (record?.site_name === "Subtotal") {
                            return <div className="subtotal">₹ {record.initial_bid_price_unit_rate_of_freight.toLocaleString('en-IN', { maximumFractionDigits: 0 }) ?? ""}</div>;
                        } else if (record?.site_name === "City Total") {
                            return <div className="citytotal">₹ {record.initial_bid_price_unit_rate_of_freight.toLocaleString('en-IN', { maximumFractionDigits: 0 }) ?? ""}</div>;
                        } else {
                            return <div className="normal-field">₹ {record.initial_bid_price_unit_rate_of_freight.toLocaleString('en-IN', { maximumFractionDigits: 0 }) ?? ""}</div>;
                        }
                    },
                },
                !hideR0 && {
                    title: "Date",
                    dataIndex: "initial_bid_price_date",
                    key: "initial_bid_price_date",
                    width: 150,
                    render: (text, record) => {
                        return (
                            <div>
                                {record.material_type_name && (
                                    <>{record.initial_bid_price_date ?? ""}</>
                                )}
                            </div>
                        );
                    },
                },
            ].filter(Boolean),
        },



        !hideR1 &&
        revisedDate && {
            title: "R1",
            children: [
                (buyingPattern === "Unit Rate of Cement including Freight" ||
                buyingPattern === "Unit Rate of Cement excluding Freight") &&
                showUnitRateOfCement && {
                    title: "Unit Rate",
                    dataIndex: "revised_bid_price_unit_rate",
                    className: 'column-right',
                    width: 150,
                    key: "revised_bid_price_unit_rate",
                    render: (text, record) => {
                        const isSubtotal = record.isSubtotal;
                        let grandTotal = 0;
                        grandTotal += record.revised_bid_price_unit_rate;

                        if (record?.site_name === "Subtotal") {
                            return <div className="subtotal">₹ {record.revised_bid_price_unit_rate.toLocaleString('en-IN', { maximumFractionDigits: 0 }) ?? ""}</div>;
                        } else if (record?.site_name === "City Total") {
                            return <div className="citytotal">₹ {record.revised_bid_price_unit_rate.toLocaleString('en-IN', { maximumFractionDigits: 0 }) ?? ""}</div>;
                        } else {
                            return <div className="normal-field">₹ {record.revised_bid_price_unit_rate.toLocaleString('en-IN', { maximumFractionDigits: 0 }) ?? ""}</div>;
                        }
                    },
                },

                buyingPattern === "Unit Rate of Cement excluding Freight" &&
                showUnitRateOfFreight && {
                    title: "Unit Rate of Freight",
                    dataIndex: "revised_bid_price_unit_rate_of_freight",
                    key: "revised_bid_price_unit_rate_of_freight",
                    render: (text, record) => {
                        const isSubtotal = record.isSubtotal;
                        let grandTotal = 0;
                        grandTotal += record.revised_bid_price_unit_rate_of_freight;
                        if (record?.site_name === "Subtotal") {
                            return <div className="subtotal">₹ {record.revised_bid_price_unit_rate_of_freight.toLocaleString('en-IN', { maximumFractionDigits: 0 }) ?? ""}</div>;
                        } else if (record?.site_name === "City Total") {
                            return <div className="citytotal">₹ {record.revised_bid_price_unit_rate_of_freight.toLocaleString('en-IN', { maximumFractionDigits: 0 }) ?? ""}</div>;
                        } else {
                            return <div className="normal-field">₹ {record.revised_bid_price_unit_rate_of_freight.toLocaleString('en-IN', { maximumFractionDigits: 0 }) ?? ""}</div>;
                        }
                    },
                },
                !hideR1 &&
                revisedDate && {
                    title: "Date",
                    dataIndex: "revised_bid_price_date",
                    key: "revised_bid_price_date",
                    render: (text, record) => {
                        return (
                            <div>
                                {record.material_type_name && (
                                    <>{record.revised_bid_price_date ?? ""} </>
                                )}
                            </div>
                        );
                    },
                },
            ].filter(Boolean),
        },
        finalDate && {
            title: "R",
            children: [
                (buyingPattern === "Unit Rate of Cement including Freight" ||
                buyingPattern === "Unit Rate of Cement excluding Freight") &&
                showUnitRateOfCement && {
                    title: "Unit Rate",
                    dataIndex: "final_bid_price_unit_rate",
                    className: 'column-right',
                    width: 150,
                    key: "final_bid_price_unit_rate",
                    render: (text, record) => {
                        const isSubtotal = record.isSubtotal;
                        let grandTotal = 0;
                        grandTotal += record.final_bid_price_unit_rate;
                        if (record?.site_name === "Subtotal") {
                            return <div className="subtotal">₹ {record.final_bid_price_unit_rate.toLocaleString('en-IN', { maximumFractionDigits: 0 }) ?? ""}</div>;
                        } else if (record?.site_name === "City Total") {
                            return <div className="citytotal">₹ {record.final_bid_price_unit_rate.toLocaleString('en-IN', { maximumFractionDigits: 0 }) ?? ""}</div>;
                        } else {
                            return <div className="normal-field">₹ {record.final_bid_price_unit_rate.toLocaleString('en-IN', { maximumFractionDigits: 0 }) ?? ""}</div>;
                        }
                    },
                },
                buyingPattern === "Unit Rate of Cement excluding Freight" &&
                showUnitRateOfFreight && {
                    title: "Unit Rate of Freight",
                    dataIndex: "final_bid_price_unit_rate_of_freight",
                    width: 150,
                    key: "final_bid_price_unit_rate_of_freight",
                    render: (text, record) => {
                        const isSubtotal = record.isSubtotal;
                        let grandTotal = 0;
                        grandTotal += record.final_bid_price_unit_rate_of_freight;

                        if (record?.site_name === "Subtotal") {
                            return <div className="subtotal"> {`₹ ${record.final_bid_price_unit_rate_of_freight.toLocaleString('en-IN')}`}</div>;
                        } else if (record?.site_name === "City Total") {
                            return <div className="citytotal">{`₹ ${record.final_bid_price_unit_rate_of_freight.toLocaleString('en-IN')}`}</div>;
                        } else {
                            return <div className="normal-field">{`₹ ${record.final_bid_price_unit_rate_of_freight.toLocaleString('en-IN')}`}</div>;
                        }
                    },
                },
                finalDate && {
                    title: "Date",
                    dataIndex: "final_bid_price_date",
                    key: "final_bid_price_date",
                    width: 150,
                    render: (text, record) => {
                        return (
                            <div>
                                {record.material_type_name && (
                                    <>{record.final_bid_price_date ?? ""}</>
                                )}
                            </div>
                        );
                    },
                },
            ].filter(Boolean),
        },
        // {
        //     title: "LQP for this client",
        //     dataIndex: "lqp_for_this_client",
        //     key: "lqp_for_this_client",
        //     render: (lqp_for_this_client, record) => {
        //         if (record?.site_name === "Subtotal") {
        //             return <div className="subtotal"> ₹ {lqp_for_this_client?.toLocaleString('en-IN', { maximumFractionDigits: 0 }) || 0}</div>;
        //         } else if (record?.site_name === "City Total") {
        //             return <div className="citytotal">₹ {lqp_for_this_client?.toLocaleString('en-IN', { maximumFractionDigits: 0 }) || 0}</div>;
        //         } else {
        //             return <div className="normal-field">₹ {lqp_for_this_client?.toLocaleString('en-IN', { maximumFractionDigits: 0 }) || 0}</div>;
        //         }
        //     },
        // },
        // {
        //     title: "LQP for this any client",
        //     dataIndex: "lqp_for_this_any_client",
        //     key: "lqp_for_this_any_client",
        //     render: (lqp_for_this_any_client, record) => {
        //         if (record?.site_name === "Subtotal") {
        //             return <div className="subtotal"> ₹ {lqp_for_this_any_client?.toLocaleString('en-IN', { maximumFractionDigits: 0 }) || 0}</div>;
        //         } else if (record?.site_name === "City Total") {
        //             return <div className="citytotal">₹ {lqp_for_this_any_client?.toLocaleString('en-IN', { maximumFractionDigits: 0 }) || 0}</div>;
        //         } else {
        //             return <div className="normal-field">₹ {lqp_for_this_any_client?.toLocaleString('en-IN', { maximumFractionDigits: 0 }) || 0}</div>;
        //         }
        //     },
        // },
    ].filter(Boolean);

    const columns2 = [
        {
            title: "City Name",
            dataIndex: "city_name",
            key: "city_name",
            render: (text, record) => <span>{record.city_name}</span>,
        },
        {
            title: "Site Name",
            dataIndex: "site_name",
            key: "site_name",
            render: (text, record) => (
                <div>
                    {record.bid_rfq_site_details.map((site) => (
                        <Input
                            disabled
                            key={site.site_id}
                            value={site.site_name}
                            className="InputItem"
                        />
                    ))}
                </div>
            ),
        },
        {
            title: "Amount With GST",
            dataIndex: "amount_with_gst",
            key: "amount_with_gst",
            render: (text, record) => (
                <div>
                    {record.bid_rfq_site_details.map((site) => (
                        <div key={site?.site_id}></div>
                    ))}
                    <div>
                        {(() => {
                            const bidMaterial = record.bid_rfq_site_details;
                            const materialDetails = bidMaterial.flatMap(
                                (site) => site.bid_rfq_material_details
                            );

                            const sum = materialDetails.reduce((acc, material) => {
                                return acc + (parseFloat(material.amount_with_gst) || 0);
                            }, 0);

                            return (
                                <Input disabled value={sum.toFixed(0)} className="InputItem" />
                            );
                        })()}
                    </div>
                </div>
            ),
        },
        {
            title: "Amount Without GST",
            dataIndex: "amount_without_gst",
            key: "amount_without_gst",
            render: (text, record) => (
                <div>
                    {record.bid_rfq_site_details.map((site) => (
                        <div key={site?.site_id}></div>
                    ))}
                    <div>
                        {(() => {
                            const bidMaterial = record.bid_rfq_site_details;
                            const materialDetails = bidMaterial.flatMap(
                                (site) => site.bid_rfq_material_details
                            );

                            const sum = materialDetails.reduce((acc, material) => {
                                return acc + (parseFloat(material.amount_without_gst) || 0);
                            }, 0);

                            return (
                                <Input disabled value={sum.toFixed(0)} className="InputItem" />
                            );
                        })()}
                    </div>
                </div>
            ),
        },
    ];
    const columns3 = [
        {
            title: "City",
            dataIndex: "city",
            key: "city",
        },
        {
            title: "Site",
            dataIndex: "sites",
            key: "site",
            render: (sites) => (
                <div>{sites.length > 0 ? sites[0].site : "No site data"}</div>
            ),
        },
        !hideR0 &&
        {
            title: "R0",
            children: [
                {
                    title: "Amount With GST",
                    dataIndex: "sites",
                    className: 'column-right',
                    width: 150,
                    key: "amountWithGstR0",
                    render: (sites) => {

                        return (
                            <div>
                                {" "}
                                ₹
                                {sites.length > 0
                                    ? sites[0].totalAmountWithGstR0.toLocaleString('en-IN', { maximumFractionDigits: 0 })
                                    : "0.00"}
                            </div>
                        )
                    },
                },
                {
                    title: "Amount Without GST",
                    dataIndex: "sites",
                    className: 'column-right',
                    width: 150,
                    key: "amountWithoutGstR0",
                    render: (sites) => (
                        <div>
                            {" "}
                            ₹
                            {sites.length > 0
                                ? sites[0].totalAmountWithoutGstR0.toLocaleString('en-IN', { maximumFractionDigits: 0 })
                                : "0.00"}
                        </div>
                    ),
                },
            ],
        },
        !hideR1 &&
        revisedDate && {
            title: "R1",
            children: [
                {
                    title: "Amount With GST",
                    dataIndex: "sites",
                    className: 'column-right',
                    width: 150,
                    key: "amountWithGstR1",
                    render: (sites) => (
                        <div>
                            {" "}
                            ₹
                            {sites.length > 0
                                ? sites[0].totalAmountWithGstR1.toLocaleString('en-IN', { maximumFractionDigits: 0 })
                                : "0.00"}
                        </div>
                    ),
                },
                {
                    title: "Amount Without GST",
                    dataIndex: "sites",
                    className: 'column-right',
                    width: 150,
                    key: "amountWithoutGstR1",
                    render: (sites) => (
                        <div>
                            {" "}
                            ₹
                            {sites.length > 0
                                ? sites[0].totalAmountWithoutGstR1.toLocaleString('en-IN', { maximumFractionDigits: 0 })
                                : "0.00"}
                        </div>
                    ),
                },
            ],
        },
        finalDate && {
            title: "R",
            children: [
                {
                    title: "Amount With GST",
                    dataIndex: "sites",
                    className: 'column-right',
                    width: 150,
                    key: "amountWithGstR",
                    render: (sites) => (
                        <div>
                            {" "}
                            ₹
                            {sites.length > 0
                                ? sites[0].totalAmountWithGstR.toLocaleString('en-IN', { maximumFractionDigits: 0 })
                                : "0.00"}
                        </div>
                    ),
                },
                {
                    title: "Amount Without GST",
                    dataIndex: "sites",
                    className: 'column-right',
                    width: 150,
                    key: "amountWithoutGstR",
                    render: (sites) => (
                        <div>
                            {" "}
                            ₹
                            {sites.length > 0
                                ? sites[0].totalAmountWithoutGstR.toLocaleString('en-IN', { maximumFractionDigits: 0 })
                                : "0.00"}
                        </div>
                    ),
                },
            ],
        },
    ].filter(Boolean);


    useEffect(() => {
        const transformedData = [];

        // Filter out "City Total" rows
        const filteredTableData = tableData.filter((item) => item.site_name !== "City Total");
        const cityMap = new Map();

        filteredTableData.forEach((item) => {
            if (item.site_name === "Subtotal") {
                const cityKey = item.siteId;
                const cityData = cityMap.get(cityKey);

                if (cityData) {
                    const subtotalData = {
                        site: "Subtotal",
                        totalAmountWithGst: cityData.sites.reduce(
                            (sum, site) => sum + site.totalAmountWithGstR,
                            0
                        ),
                        totalAmountWithoutGst: cityData.sites.reduce(
                            (sum, site) => sum + site.totalAmountWithoutGst,
                            0
                        ),
                    };
                    cityData.sites.push(subtotalData);
                }
            } else if (item.site_name) {
                const siteData = {
                    site_id: item.siteId,
                    site: item.site_name,
                    totalAmountWithGstR0: 0,
                    totalAmountWithoutGstR0: 0,
                    totalAmountWithGstR1: 0,
                    totalAmountWithoutGstR1: 0,
                    totalAmountWithGstR: 0,
                    totalAmountWithoutGstR: 0,
                };

                const materialData = filteredTableData.filter(
                    (data) => data.siteId === item.siteId && data.site_name !== "Subtotal"
                );

                // Correct calculation for initial bid
                siteData.totalAmountWithGstR0 = materialData.reduce((sum, material) => {
                    const unitRate =
                        (parseFloat(material.initial_bid_price_unit_rate) || 0) +
                        (parseFloat(material.initial_bid_price_unit_rate_of_freight) || 0);
                    const totalAmountWithoutGst = unitRate * (material.material_total_quantity || 0);
                    const gstAmount = totalAmountWithoutGst * ((material.gst_rate || 0) / 100);
                    return sum + totalAmountWithoutGst + gstAmount;
                }, 0);

                siteData.totalAmountWithoutGstR0 = materialData.reduce((sum, material) => {
                    const unitRate =
                        (parseFloat(material.initial_bid_price_unit_rate) || 0) +
                        (parseFloat(material.initial_bid_price_unit_rate_of_freight) || 0);
                    return sum + unitRate * (material.material_total_quantity || 0);
                }, 0);

                // Correct calculation for revised bid
                siteData.totalAmountWithGstR1 = materialData.reduce((sum, material) => {
                    const unitRate =
                        (parseFloat(material.revised_bid_price_unit_rate) || 0) +
                        (parseFloat(material.revised_bid_price_unit_rate_of_freight) || 0);
                    const totalAmountWithoutGst = unitRate * (material.material_total_quantity || 0);
                    const gstAmount = totalAmountWithoutGst * ((material.gst_rate || 0) / 100);
                    return sum + totalAmountWithoutGst + gstAmount;
                }, 0);

                siteData.totalAmountWithoutGstR1 = materialData.reduce((sum, material) => {
                    const unitRate =
                        (parseFloat(material.revised_bid_price_unit_rate) || 0) +
                        (parseFloat(material.revised_bid_price_unit_rate_of_freight) || 0);
                    return sum + unitRate * (material.material_total_quantity || 0);
                }, 0);

                // Correct calculation for final bid
                siteData.totalAmountWithGstR = materialData.reduce((sum, material) => {
                    const unitRate =
                        (parseFloat(material.final_bid_price_unit_rate) || 0) +
                        (parseFloat(material.final_bid_price_unit_rate_of_freight) || 0);
                    const totalAmountWithoutGst = unitRate * (material.material_total_quantity || 0);
                    const gstAmount = totalAmountWithoutGst * ((material.gst_rate || 0) / 100);
                    return sum + totalAmountWithoutGst + gstAmount;
                }, 0);

                siteData.totalAmountWithoutGstR = materialData.reduce((sum, material) => {
                    const unitRate =
                        (parseFloat(material.final_bid_price_unit_rate) || 0) +
                        (parseFloat(material.final_bid_price_unit_rate_of_freight) || 0);
                    return sum + unitRate * (material.material_total_quantity || 0);
                }, 0);

                const cityKey = item.siteId;
                if (!cityMap.has(cityKey)) {
                    cityMap.set(cityKey, { city: item.city_name, sites: [] });
                }

                const cityData = cityMap.get(cityKey);
                if (!cityData.sites.some((site) => site.site === siteData.site)) {
                    cityData.sites.push(siteData);
                }
            }
        });

        const finalData = Array.from(cityMap.values());
        setSummaryTableData(finalData);
    }, [tableData, resetMode, setSummaryTableData]);




    const handleCheckboxChange = (e) => {
        const value = e.target.checked;
        setState((prevState) => ({
            ...prevState,
            is_final_bid_price: value,
        }));
    };

    const resetUnitRateWithGst = (item) => {
        item.bid_rfq_site_details.forEach((site) => {
            site.bid_rfq_material_details.forEach((material) => {
                material.unit_rate_with_gst = null;
            });
        });
        return item;
    };
    const handleBidSubmission = () => {
        if (state.is_final_bid_price) {
            handleSubmit();
        } else {
            handleSubmit();
            resetGSTValues();
            setCurrentStep(currentStep + 1);
        }
    };

    useEffect(() => {
        if (currentStep === 3) {
            //   navigate(`/rfq-vendor-request-for-quotation/history/1`);
        }
    }, [currentStep, CategoryId]);

    const handleSubmit = async () => {
        const currentDate = (() => {
            const today = new Date();
            const dd = String(today.getDate()).padStart(2, "0");
            const mm = String(today.getMonth() + 1).padStart(2, "0");
            const yyyy = today.getFullYear();
            return `${dd}-${mm}-${yyyy}`;
        })();

        const updatedTableData = tableData.map((item) => {
            if (!item.isSubtotal && item.material_type_name) {
                return {
                    ...item,
                    initial_bid_price_date: currentDate,
                    revised_bid_price_date: currentDate,
                    final_bid_price_date: currentDate,
                };
            }
            return item;
        });

        setTableData(updatedTableData);
        const uniqueEntries = new Map();
        const payload = {
            vendor: VendorId,
            bid_rfq_city_wise_detail: Array.from(
                tableData
                    .reduce((cities, entry) => {
                        if (!entry.siteId || entry.isSubtotal) return cities;

                        const key = `${entry.siteId}_${entry.material_type}`;
                        if (!uniqueEntries.has(key)) {
                            uniqueEntries.set(key, true);
                            if (!cities.has(entry.city_name)) {
                                cities.set(entry.city_name, []);
                            }
                            cities.get(entry.city_name).push({
                                site_id: entry.siteId,
                                site_name: entry.site_name,
                                site_wise_uom: entry.material_wise_uom,
                                bid_rfq_material_details: [
                                    {
                                        material_type: entry.material_type,
                                        initial_bid_price_unit_rate:
                                        entry.initial_bid_price_unit_rate,
                                        initial_bid_price_date: entry.initial_bid_price_date,
                                        initial_bid_price_unit_rate_of_freight:
                                        entry.initial_bid_price_unit_rate_of_freight,
                                        revised_bid_price_unit_rate:
                                        entry.revised_bid_price_unit_rate,
                                        revised_bid_price_date: entry.revised_bid_price_date,
                                        revised_bid_price_unit_rate_of_freight:
                                        entry.initial_bid_price_unit_rate_of_freight,
                                        final_bid_price_unit_rate:
                                        entry.initial_bid_price_unit_rate,
                                        final_bid_price_unit_rate_of_freight:
                                        entry.initial_bid_price_unit_rate_of_freight,
                                        final_bid_price_date: entry.final_bid_price_date,
                                    },
                                ],
                            });
                        }
                        return cities;
                    }, new Map())
                    .values()
            ),
        };

        try {
            setLoading(true);
            let response;
            response = await patchRequest(
                `bid-rfq/${vendorBidId}/create-bid-rfq22/`,
                payload
            );

            if (response.data.success) {
                setLoading(false);

                let responseData = await getRequest(
                    `bid-rfq/${vendorBidId}/get-bid-rfq-city-wise/?vendor_id=${VendorId}22`
                );

                if (currentStep === 0) {
                    SuccessNotificationMsg(t("bidding_of_R0"));
                } else if (currentStep === 1) {
                    SuccessNotificationMsg(t("bidding_of_R1"));
                } else {
                    SuccessNotificationMsg(t("bidding_of_R"));
                }

                const newState2 = {
                    vendor: VendorId,
                    bid_rfq_vendor_detail:
                        responseData.data.data[0].rfq_site_wise_vendor.map((site) => ({
                            rfq_material_type_name: site.rfq_material_type_name,
                            rfq_material_type: site.rfq_material_type_id,
                            bid_rfq_detail: site.bid_rfq_detail.map((detail) => ({
                                id: detail.bid_rfq_id,
                                rfq_vendor_detail: detail.rfq_vendor_detail_id,
                                purchase_requisition_site_id:
                                detail.purchase_requisition_site_id,
                                purchase_requisition_site_name:
                                detail.purchase_requisition_site_name,
                                site_wise_total_quantity: detail.site_wise_total_quantity,
                                initial_bid_price_unit_rate: detail.initial_bid_price_unit_rate,
                                initial_bid_price_unit_rate_of_freight:
                                detail.initial_bid_price_unit_rate_of_freight,
                                initial_bid_price_total_unit_rate:
                                detail.initial_bid_price_total_unit_rate,
                                initial_bid_price_date: currentDate,
                                revised_bid_price_unit_rate: detail.revised_bid_price_unit_rate,
                                revised_bid_price_unit_rate_of_freight:
                                detail.revised_bid_price_unit_rate_of_freight,
                                revised_bid_price_total_unit_rate:
                                detail.revised_bid_price_total_unit_rate,
                                final_bid_price_unit_rate: detail.final_bid_price_unit_rate,
                                final_bid_price_unit_rate_of_freight:
                                detail.final_bid_price_unit_rate_of_freight,
                                final_bid_price_total_unit_rate:
                                detail.final_bid_price_total_unit_rate,
                            })),
                        })),
                };

                setNewState2(newState2);
                setTableData(newState2);
                SuccessNotificationMsg(t("bidding_of_R0"));
            }
        } catch (error) {
            setLoading(false);
        }
    };
    const dataSource = {
        isFinalBidPrice: false,
        company: null,
        rfqNumber: null,
        currency: null,
        priceBasis: null,
        freight: null,
        unloading: null,
        transportInsurance: null,
        openOrder: false,
        amountCap: null,
        timelineCap: null,
        deliveryDate: null,
        deliveryStartDate: null,
        deliveryEndDate: null,
        rfqDueDate: null,
        bidRfqCityWiseDetail: [
            {
                cityName: null,
                cityId: null,
                bidRfqSiteDetails: [
                    {
                        siteId: null,
                        siteName: null,
                        siteWiseUom: null,
                        totalUnitRateOfCement: "",
                        rfqVendorDetail: "",
                        bidRfqMaterialDetails: [
                            {
                                materialTypeName: null,
                                rfqMaterialDetail: null,
                                gstRate: null,
                                materialType: null,
                                materialTotalQuantity: null,
                                materialWiseUom: null,
                                initialBidPriceUnitRate: null,
                                initialBidPriceUnitRateOfFreight: null,
                                revisedBidPriceUnitRate: null,
                                revisedBidPriceUnitRateOfFreight: null,
                                finalBidPriceUnitRate: null,
                                finalBidPriceUnitRateOfFreight: null,
                                unitRateWithGst: null,
                                amountWithoutGst: null,
                                amountWithGst: null,
                                lqpForThisClient: 5678,
                                lqpForThisAnyClient: 2290,
                            },
                        ],
                    },
                ],
            },
        ],
    };

    return (
        <>
        <div className="ListingTopBar">
            <div className="pagenamewrap">
                <div className="pagename">
                    <h3>View - BID RFQ Vendor</h3>

                    <Breadcrumb className="Breadcrumb-Sec">
                        <Breadcrumb.Item>
                            <Link to="/dashboard">{t("home")}</Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <Link to="/rfq-vendor-request-for-quotation/history/1">
                                {t("RFQ History - Vendor")}
                            </Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>View - BID RFQ Vendor</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
            </div>
        </div>
        <section className="grid-sec citywise">
            <div className="PR-body">
                <Collapse defaultActiveKey={[1]} key={0} className="rgqdtlcollapse">
                    <Panel header={"RFQ Details"} key={0}>
                        <div className="rgq-num-wrap wrap">
                            <h5 className="rfq-number new">
                                Company Name : <span>{companyName}</span>
                            </h5>
                            <h5 className="rfq-number new">
                                RFQ Number : <span>{rfqnumber}</span>
                            </h5>
                            <h5 className="rfq-number new">
                                Currency : <span>{rfqcurrency}</span>
                            </h5>
                            <h5 className="rfq-number new">
                                Price Basis : <span>{rfqpricebasis}</span>
                            </h5>
                            <h5 className="rfq-number new">
                                Freight : <span>{rfqfreight}</span>
                            </h5>
                            <h5 className="rfq-number new">
                                Unloading : <span>{rfqunloading}</span>
                            </h5>
                            <h5 className="rfq-number new">
                                Transport Insurance : <span>{rfqtransportInsurance}</span>
                            </h5>
                            <h5 className="rfq-number new">
                                RFQ Due Date : <span>{rfqData.rfqduedate}</span>
                            </h5>
                            {!rfqData.open_order && (
                                <h5 className="rfq-number new">
                                    Delivery Date : <span>{rfqData.rfqopendeliverydate}</span>
                                </h5>
                            )}

                            <>
                            {rfqData.open_order && (
                                <>
                                <h5 className="rfq-number new">
                                    Amount Cap : <span>{rfqData.rfqamountcap}</span>
                                </h5>
                                <h5 className="rfq-number new">
                                    Timeline Cap : <span>{rfqData.rfqtimelinecap}</span>
                                </h5>
                                <h5 className="rfq-number new">
                                    Delivery Start Date :{" "}
                                    <span>{rfqData.rfqdeliverystartdate}</span>
                                </h5>
                                <h5 className="rfq-number new">
                                    Delivery End Date :{" "}
                                    <span>{rfqData.rfqdeliveryenddate}</span>
                                </h5>

                                {/* <h5 className="rfq-number new">
                                 Price Cap : <span>{rfqData.rfqpricecap}</span>
                                 </h5> */}
                                </>
                            )}
                            </>
            </div>
        </Panel>
        </Collapse>
    <div>
        <Form autoComplete="off" ref={formRef} onFinish={handleSubmit}>
            <Spin spinning={apiLoading}>
                <Table
                    columns={columns}
                    tableLayout="auto"
                    dataSource={tableData}
                    pagination={false}
                    scroll={{
                        x: 'max-content',
                    }}
                />
                </Spin>
                <div className="footerTable2">
                <Table
                columns={columns3}
                dataSource={summaryTableData}
                pagination={false}
                bordered
                scroll={{
                x: 800,
                }}
                />
                </div>
                <div className="FormFooter">
                {revisedDate && (
                <>
                <Checkbox checked={hideR0} onChange={handleHideR0Change}>
                    Hide Initial BID Price - R0
                </Checkbox>
            </>
            )}
            {finalDate && !AsFinalBidPrice && (
            <>
            <Checkbox checked={hideR1} onChange={handleHideR1Change}>
                Hide BID Price - R1
            </Checkbox>
        </>
        )}
    </div>

    <div className="FormFooter bidftr">

        </div>
        </Form>
        </div>
        </div>
        </section>
        </>
        );
        };

export default VendorViewRFQBidDetail;
